// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point } from '@shared/commons/Geometry';
import { ChartMath } from '../Utils/ChartMath';
import { ToolView } from './ToolView';
export class GannLineToolView extends ToolView {
    IsSelectCheck(x, y) {
        const scrP = this.screenPoints[0];
        return (ChartMath.CalcDistanceFromPointToPoint(new Point(x, y), new Point(scrP[0], scrP[1])) <=
            ToolView.POINT_DX * 2);
    }
    DrawGannLine(gr, ww, highlight) {
        const cacheTool = this.dataCacheTool;
        const mirrored = cacheTool.mirrored;
        const pen = highlight ? cacheTool.PenHighlight : cacheTool.Pen;
        const clientRect = ww.ClientRectangle;
        const screenPoints = this.screenPoints;
        const scrP = screenPoints[0];
        const x = scrP[0];
        const y = scrP[1];
        if (mirrored) {
            gr.DrawLine(pen, x, y, x + (clientRect.Height - y) / Math.tan(Math.atan(1 / 1.0)), clientRect.Height);
        }
        else {
            gr.DrawLine(pen, x, y, x + y / Math.tan(Math.atan(1 / 1.0)), 0);
        }
    }
    Draw(gr, ww, param) {
        this.DrawGannLine(gr, ww, false);
        super.Draw(gr, ww, param);
    }
    DrawSelection(gr, ww) {
        this.DrawGannLine(gr, ww, true);
        super.DrawSelection(gr, ww);
    }
}
